import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { DatePipe } from '@angular/common';
declare var $: any;
import * as _ from 'lodash';
import { AlertComponent } from 'src/app/structure/alert/alert.component';

@Component({
  selector: 'app-mgt1add',
  templateUrl: './mgt1add.component.html',
  styleUrls: ['./mgt1add.component.css']
})
export class Mgt1addComponent implements OnInit {

  detailsOfSharesForm: FormGroup;
  dosList: any = [];
  personaldetailsForm: FormGroup;
  personaldetailsList: any = [];
  detailsOfMembersForm: FormGroup;
  domList: any = [];
  isMinor: any;
  isJointHolder: any;
  editParticularId: any;
  editParticularData: any;
  addPersonaldetailsBtn = true;
  boardResolutionDateB: any;
  addDomBtn = true;
  doBecomingMember: any;
  doReceiptOfNomination: any;
  doCessationOfMemebership: any;
  restrictmgt1: boolean;
  addButton = true;
  adddomfrom = true;
  typeOfShareholder: any;
  dateOfBoardResolution: { month: number; day: number; year: number; };
  dateOfBirth: { month: number; day: number; year: number; };
  dateOfBecomingMember: { month: number; day: number; year: number; };
  doDeclaration: { month: number; day: number; year: number; };
  dateOfReceiptOfNomination: { month: number; day: number; year: number; };
  dateOfCessation: { month: number; day: number; year: number; };
  minorMaritialStatus: any;
  uniqueIdentification: any;
  filesToUpload: Array<File>;
  fileAvailable = false;
  canRevert: boolean;
  resolutionFileName: any;
  documentManagementID: any;
  public environmentSettings: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  FileOrignalName: any;
  changedName: any;
  countryList: any[];
  newFieldArray: { id: number; title: string; }[];
  addNewTermsheetFieldForm: FormGroup;
  newFieldAttribute: any;
  defaultSelected: any;
  typeOfHolding: any;
  holdingList: any;
  newField: any;
  dtTriggerHolding: Subject<any> = new Subject();
  dtOptionsOfHolding: DataTables.Settings = {};
  deleteholdingId: any;
  addholding = true;
  holdingdata: any;
  typesOfHolders: any;
  holdersdata: any;
  disabledOnClick: boolean;
  fileExtension: boolean = true;
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  dateFrom: any;
  dateTo: any;
  isSearchDivVisible = false;
  // dAllotment: { month: number; day: number; year: number; };
  // dOfIssue: { month: number; day: number; year: number; };
  // dOfTransfer: { month: number; day: number; year: number; };
  // dOfTransmission: { month: number; day: number; year: number; };
  // dOfForfeiture: { month: number; day: number; year: number; };
  // dOfRedemption: { month: number; day: number; year: number; };
  // dOfBuyback: { month: number; day: number; year: number; };
  array: any;
  pipe: any;
  token: any = localStorage.getItem('token')
  response: boolean;
  constructor(private mgt1Service: Mgt1Service, private activatedRoute: ActivatedRoute, private commonFunction: CommonFunction,
    private alert: AlertComponent, private documentManagementMasterService: DocumentManagementMasterService,
    private directorMasterService: DirectorMasterService, private formBuilder: FormBuilder,private router: Router, 
    private route: ActivatedRoute) { }

  ngOnInit() {

    this.detailsOfSharesForm = new FormGroup({
      selectTypes: new FormControl('', [Validators.required]),
      nominalValuePerUnit: new FormControl('', [Validators.pattern("^[0-9,.-]*$"), Validators.maxLength(14)]),
      totalNoOfSharesHeld: new FormControl('', [Validators.required, Validators.pattern("^[0-9,.-]*$"), Validators.maxLength(14)]),
      folioNoDematAcNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 /,.-]*$"), Validators.maxLength(30)]),
    })

    this.personaldetailsForm = new FormGroup({
      typesOfShareholders: new FormControl('', [Validators.required]),
      nameOfMember: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      jointHolders: new FormControl('', []),
      nameOfjointHolders: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      address: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'\n-]*$"), Validators.maxLength(50)]),
      // panNo : new FormControl('',[Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      panNo: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      jointHoldersPanNo: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      uin: new FormControl('', []),
      passportNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      adharNumber: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      voterId: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      others: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      nationality: new FormControl('', []),
      emailid: new FormControl('', [Validators.pattern("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,}$"), Validators.maxLength(50)]),
      fatherName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      motherName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      inCaseMemberisMinor: new FormControl('', []),
      dob: new FormControl('', []),
      nameAndAddressOfGuardian: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'\n-]*$"), Validators.maxLength(150)]),
      maritialStatus: new FormControl('', []),
      spouseName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      occupation: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      // nameOfMemberB : new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z]*$")]),
      // address : new FormControl('',[]),
      // panNo : new FormControl('',[Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      cinRegistrationNoB: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(21)]),
      // emailid : new FormControl('',[Validators.pattern("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")]),
      nameB: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      designationB: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$")]),
      boardResolutionDateB: new FormControl('', []),
      uploadCopyOfResolutionB: new FormControl('', []),
      // nameOfMemberO : new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z]*$")]),
      // address : new FormControl('',[]),
      // panNo : new FormControl('',[Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      // uin : new FormControl('',[]),
      // passportNumber : new FormControl('',[]),
      // adharNumber : new FormControl('',[]),
      // voterId : new FormControl('',[]),
      // others : new FormControl('',[]),
      // emailid : new FormControl('',[Validators.pattern("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")]),
    })

    this.detailsOfMembersForm = new FormGroup({
      doBecomingMember: new FormControl('', [Validators.required]),
      dateOfDeclaration: new FormControl('', []),
      addNoterelatedToDeclaration: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.&%()\n-]*$")]),
      nameOfBeneficialowner: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(30)]),
      addressOfBeneficialOwner: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'\n-]*$"), Validators.maxLength(100)]),
      doReceiptOfNomination: new FormControl('', []),
      nameAndAddressOfNominee: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'\n-]*$")]),
      noOfSharesKeptInAbeyance: new FormControl('', [Validators.pattern("^[0-9 .]*$"), Validators.maxLength(20)]),
      recordOfLienOnShares: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&-]*$"), Validators.maxLength(100)]),
      doCessationOfMemebership: new FormControl('', []),
      particularsOfDmPoa: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&-]*$"), Validators.maxLength(150)]),
      amountOfGuaranee: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(15)]),
      anyOtherInterest: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&\n-]*$"), Validators.maxLength(50)]),
      instructionForSendingNotices: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&\n-]*$"), Validators.maxLength(150)]),
    })

    this.addNewTermsheetFieldForm = this.formBuilder.group({
      newField: new FormArray([
        // this.initialiseNewFieldArray()
      ]),
    });

    this.newFieldArray = [];

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictmgt1 = true;
        this.addPersonaldetailsBtn = false;
        this.addDomBtn = false;
        this.editParticularId = params['particularId'];
        this.getMgt1DetailsById(this.editParticularId);
        // this.isJointHolder = false;
      } else {
        this.restrictmgt1 = false;
      }
    })
    this.getAllNations();


    this.dtOptionsOfHolding = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: []

    };
    //  this.getHoldingList();
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getAllNations() {
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
    this.directorMasterService.getNations().subscribe((relativeUpdate:any) => {
      console.log(relativeUpdate);
      this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
    });
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
  }

  typesOfShareholder(value) {

    this.typeOfShareholder = value;
    if (value == 'Body Corporate') {
      this.personaldetailsForm.controls.cinRegistrationNoB.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(21)]);
    } else {
      this.personaldetailsForm.controls.cinRegistrationNoB.setValidators([Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(21)]);
      this.personaldetailsForm.controls.cinRegistrationNoB.updateValueAndValidity();
    }
  }

  changeTypesOfShareholders() {
    this.personaldetailsForm.controls.cinRegistrationNoB.setValue('');
    this.personaldetailsForm.controls.nameB.setValue('');
    this.personaldetailsForm.controls.designationB.setValue('');
    this.personaldetailsForm.controls.boardResolutionDateB.setValue(null);
    this.uniqueIdentification = '';
    this.personaldetailsForm.controls.nationality.setValue('');
    this.personaldetailsForm.controls.fatherName.setValue('');
    this.personaldetailsForm.controls.motherName.setValue('');
    this.personaldetailsForm.controls.occupation.setValue('');
    this.personaldetailsForm.controls.inCaseMemberisMinor.setValue('');
    this.personaldetailsForm.controls.jointHolders.setValue(null);
    this.personaldetailsForm.controls.uin.setValue('');
    this.personaldetailsForm.controls.maritialStatus.setValue(null);
    this.minorMaritialStatus = '';
    // this.uinChanged();
    this.jointHolderNoClick();
    // this.hideMinorNoClick();
    this.personaldetailsForm.controls.dob.setValue(null);
    this.personaldetailsForm.controls.nameAndAddressOfGuardian.setValue('');

  }
  memberisMinorChanged() {
    this.personaldetailsForm.controls.dob.setValue(null);
    this.personaldetailsForm.controls.nameAndAddressOfGuardian.setValue('');
  }

  showMinorYesClick() {
    this.isMinor = 'yes';
    this.minorMaritialStatus = '';
    this.personaldetailsForm.controls.maritialStatus.setValue('');
  }

  hideMinorNoClick() {
    this.isMinor = 'no';
    this.minorMaritialStatus = '';
    this.personaldetailsForm.controls.maritialStatus.setValue('');
  }

  jointHolderYesClick() {
    this.isJointHolder = 'yes';
  }

  jointHolderNoClick() {
    this.isJointHolder = 'no';
    this.personaldetailsForm.controls.nameOfjointHolders.setValue('');
    this.personaldetailsForm.controls.jointHoldersPanNo.setValue('');
  }

  uinChanged() {
    this.uniqueIdentification = this.personaldetailsForm.controls.uin.value;
    console.log("uniqueIdentification", this.uniqueIdentification);
    this.personaldetailsForm.controls.passportNumber.setValue('');
    this.personaldetailsForm.controls.adharNumber.setValue('');
    this.personaldetailsForm.controls.voterId.setValue('');
    this.personaldetailsForm.controls.others.setValue('');
  }

  maritialStatusChanged() {
    this.minorMaritialStatus = this.personaldetailsForm.controls.maritialStatus.value;
    // if(this.maritialStatus=='single'){
    this.personaldetailsForm.controls.spouseName.setValue('');
    // }
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }
  typesOfHoldersChanged() {
    var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    var formGroup: FormGroup = <FormGroup>formArray.controls[0];

    formGroup.controls.folioOfTransferor.setValue('');
    formGroup.controls.nameOfTransferor.setValue('');
    formGroup.controls.balancesharesbuyback.setValue('');
    formGroup.controls.balancesharesredemption.setValue('');
    formGroup.controls.balancesharesforfeiture.setValue('');
    formGroup.controls.balancesharestransmission.setValue('');
    formGroup.controls.balancesharestransfer.setValue('');
    formGroup.controls.nameOfTransferee.setValue('');
    formGroup.controls.folioOfTransferee.setValue('');
    formGroup.controls.noofsharestransfer.setValue('');
    formGroup.controls.noofsharestransmission.setValue('');
    formGroup.controls.noofsharesforfeiture.setValue('');
    formGroup.controls.noofsharesredemption.setValue('');
    formGroup.controls.noofsharesbuyback.setValue('');
    formGroup.controls.distinctiveTransferredFrom.setValue('');
    formGroup.controls.distinctiveTransferredTo.setValue('');
    formGroup.controls.distinctiveTransmittedFrom.setValue('');
    formGroup.controls.distinctiveTransmittedTo.setValue('');
    formGroup.controls.distinctiveForfeitedFrom.setValue('');
    formGroup.controls.distinctiveForfeitedTo.setValue('');
    formGroup.controls.distinctiveRedeemedFrom.setValue('');
    formGroup.controls.distinctiveRedeemedTo.setValue('');
    formGroup.controls.distinctiveBuybackFrom.setValue('');
    formGroup.controls.distinctiveBuybackTo.setValue('');
    formGroup.controls.dateOfTransfer.setValue(null);
    // formGroup.controls.dateOfTransmission.setValue(null);
    // formGroup.controls.dateOfForfeiture.setValue(null);
    // formGroup.controls.dateOfRedemption.setValue(null);
    // formGroup.controls.dateOfBuyback.setValue(null);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  saveDetailsOfSharesForm() {
    this.disabledOnClick = true;
    var object = {
      selectTypes: this.detailsOfSharesForm.controls.selectTypes.value,
      nominalValuePerUnit: this.detailsOfSharesForm.controls.nominalValuePerUnit.value,
      totalNoOfSharesHeld: this.detailsOfSharesForm.controls.totalNoOfSharesHeld.value,
      folioNoDematAcNo: this.detailsOfSharesForm.controls.folioNoDematAcNo.value,
    }

    this.mgt1Service.saveDetailsOfShares(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.restrictmgt1 = true;
        this.alert.success(response.message);
        this.editParticularId = response.data._id;
      } else {

        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else {
          this.alert.error(response.message);
        }
      }
      console.log("response", response);
    })
  }

  updateDetailsOfSharesForm(_id) {
    this.disabledOnClick = true;
    console.log("_id", this.editParticularId);
    var object = {
      selectTypes: this.detailsOfSharesForm.controls.selectTypes.value,
      nominalValuePerUnit: this.detailsOfSharesForm.controls.nominalValuePerUnit.value,
      totalNoOfSharesHeld: this.detailsOfSharesForm.controls.totalNoOfSharesHeld.value,
      folioNoDematAcNo: this.detailsOfSharesForm.controls.folioNoDematAcNo.value,
      particularId: this.editParticularId
    }
    this.mgt1Service.updateDetailsOfShares(object).subscribe(response => {
      this.disabledOnClick = false;
      console.log("response", object);
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        // this.alert.error(response.message);
        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else {
          this.alert.error(response.message);
        }
      }
    })
  }

  // new

  updatePersonalDetails() {
    this.disabledOnClick = true;
    var self = this;
    if (this.filesToUpload != undefined && this.filesToUpload.length > 0) {
      this.upload().then(function (response:any) {
        if (response.status == 0) {
          var personaldata = {
            typesOfShareholders: self.personaldetailsForm.controls.typesOfShareholders.value,
            nameOfMember: self.personaldetailsForm.controls.nameOfMember.value,
            jointHolders: self.personaldetailsForm.controls.jointHolders.value,
            nameOfjointHolders: self.personaldetailsForm.controls.nameOfjointHolders.value,
            address: self.personaldetailsForm.controls.address.value,
            panNo: self.personaldetailsForm.controls.panNo.value,
            jointHoldersPanNo: self.personaldetailsForm.controls.jointHoldersPanNo.value,
            uin: self.personaldetailsForm.controls.uin.value,
            passportNumber: self.personaldetailsForm.controls.passportNumber.value,
            adharNumber: self.personaldetailsForm.controls.adharNumber.value,
            voterId: self.personaldetailsForm.controls.voterId.value,
            others: self.personaldetailsForm.controls.others.value,
            nationality: self.personaldetailsForm.controls.nationality.value,
            emailid: self.personaldetailsForm.controls.emailid.value,
            fatherName: self.personaldetailsForm.controls.fatherName.value,
            motherName: self.personaldetailsForm.controls.motherName.value,
            inCaseMemberisMinor: self.personaldetailsForm.controls.inCaseMemberisMinor.value,
            dob: self.setDate(self.personaldetailsForm.controls.dob.value),
            nameAndAddressOfGuardian: self.personaldetailsForm.controls.nameAndAddressOfGuardian.value,
            maritialStatus: self.personaldetailsForm.controls.maritialStatus.value,
            spouseName: self.personaldetailsForm.controls.spouseName.value,
            occupation: self.personaldetailsForm.controls.occupation.value,
            cinRegistrationNoB: self.personaldetailsForm.controls.cinRegistrationNoB.value,
            nameB: self.personaldetailsForm.controls.nameB.value,
            designationB: self.personaldetailsForm.controls.designationB.value,
            boardResolutionDateB: self.setDate(self.personaldetailsForm.controls.boardResolutionDateB.value),
            uploadCopyOfResolutionB: self.personaldetailsForm.controls.uploadCopyOfResolutionB.value,
            particularId: self.editParticularId,
            FileOrignalName: self.FileOrignalName,
            DocumentManagementID: response.result._id,
            UploadDate: new Date(),
          }
          self.mgt1Service.updatePersonalDetails(personaldata).subscribe(response => {
            self.disabledOnClick = false;
            if (response.status == 0) {
              self.alert.success(response.message);
              // self.alert.successWithOk(response.message, '/mgt1list')
            } else {
              if (response.err_fields) {
                self.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
              } else {
                self.alert.error(response.message);
              }

            }
          })

        }
      })
    } else {
      this.disabledOnClick = true;
      var personaldata = {
        typesOfShareholders: self.personaldetailsForm.controls.typesOfShareholders.value,
        nameOfMember: self.personaldetailsForm.controls.nameOfMember.value,
        jointHolders: self.personaldetailsForm.controls.jointHolders.value,
        nameOfjointHolders: self.personaldetailsForm.controls.nameOfjointHolders.value,
        address: self.personaldetailsForm.controls.address.value,
        panNo: self.personaldetailsForm.controls.panNo.value,
        jointHoldersPanNo: self.personaldetailsForm.controls.jointHoldersPanNo.value,
        uin: self.personaldetailsForm.controls.uin.value,
        passportNumber: self.personaldetailsForm.controls.passportNumber.value,
        adharNumber: self.personaldetailsForm.controls.adharNumber.value,
        voterId: self.personaldetailsForm.controls.voterId.value,
        others: self.personaldetailsForm.controls.others.value,
        nationality: self.personaldetailsForm.controls.nationality.value,
        emailid: self.personaldetailsForm.controls.emailid.value,
        fatherName: self.personaldetailsForm.controls.fatherName.value,
        motherName: self.personaldetailsForm.controls.motherName.value,
        inCaseMemberisMinor: self.personaldetailsForm.controls.inCaseMemberisMinor.value,
        dob: self.setDate(self.personaldetailsForm.controls.dob.value),
        nameAndAddressOfGuardian: self.personaldetailsForm.controls.nameAndAddressOfGuardian.value,
        maritialStatus: self.personaldetailsForm.controls.maritialStatus.value,
        spouseName: self.personaldetailsForm.controls.spouseName.value,
        occupation: self.personaldetailsForm.controls.occupation.value,
        cinRegistrationNoB: self.personaldetailsForm.controls.cinRegistrationNoB.value,
        nameB: self.personaldetailsForm.controls.nameB.value,
        designationB: self.personaldetailsForm.controls.designationB.value,
        boardResolutionDateB: self.setDate(self.personaldetailsForm.controls.boardResolutionDateB.value),
        uploadCopyOfResolutionB: self.personaldetailsForm.controls.uploadCopyOfResolutionB.value,
        particularId: self.editParticularId,
        FileOrignalName: self.resolutionFileName,
        DocumentManagementID: self.documentManagementID,
        UploadDate: new Date(),

      }
      self.mgt1Service.updatePersonalDetails(personaldata).subscribe(response => {
        self.disabledOnClick = false;
        if (response.status == 0) {
          self.alert.success(response.message);
          // self.alert.successWithOk(response.message, '/mgt1list')
        } else {
          if (response.err_fields) {
            self.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          } else {
            self.alert.error(response.message);
          }
        }
      })

    }
  }

  // updatePersonalDetails() {
  //   var self = this;

  //   var personaldata = {
  //     typesOfShareholders: this.personaldetailsForm.controls.typesOfShareholders.value,
  //     nameOfMember: this.personaldetailsForm.controls.nameOfMember.value,
  //     jointHolders: this.personaldetailsForm.controls.jointHolders.value,
  //     nameOfjointHolders: this.personaldetailsForm.controls.nameOfjointHolders.value,
  //     address: this.personaldetailsForm.controls.address.value,
  //     panNo: this.personaldetailsForm.controls.panNo.value,
  //     jointHoldersPanNo: this.personaldetailsForm.controls.jointHoldersPanNo.value,
  //     uin: this.personaldetailsForm.controls.uin.value,
  //     passportNumber: this.personaldetailsForm.controls.passportNumber.value,
  //     adharNumber: this.personaldetailsForm.controls.adharNumber.value,
  //     voterId: this.personaldetailsForm.controls.voterId.value,
  //     others: this.personaldetailsForm.controls.others.value,
  //     nationality: this.personaldetailsForm.controls.nationality.value,
  //     emailid: this.personaldetailsForm.controls.emailid.value,
  //     fatherName: this.personaldetailsForm.controls.fatherName.value,
  //     motherName: this.personaldetailsForm.controls.motherName.value,
  //     inCaseMemberisMinor: this.personaldetailsForm.controls.inCaseMemberisMinor.value,
  //     dob: this.setDate(this.personaldetailsForm.controls.dob.value),
  //     nameAndAddressOfGuardian: this.personaldetailsForm.controls.nameAndAddressOfGuardian.value,
  //     maritialStatus: this.personaldetailsForm.controls.maritialStatus.value,
  //     spouseName: this.personaldetailsForm.controls.spouseName.value,
  //     occupation: this.personaldetailsForm.controls.occupation.value,
  //     // nameOfMemberB : this.personaldetailsForm.controls.nameOfMemberB.value,
  //     // address : this.personaldetailsForm.controls.address.value,
  //     // panNo : this.personaldetailsForm.controls.panNo.value,
  //     cinRegistrationNoB: this.personaldetailsForm.controls.cinRegistrationNoB.value,
  //     // emailid : this.personaldetailsForm.controls.emailid.value,
  //     nameB: this.personaldetailsForm.controls.nameB.value,
  //     designationB: this.personaldetailsForm.controls.designationB.value,
  //     boardResolutionDateB: this.setDate(this.personaldetailsForm.controls.boardResolutionDateB.value),
  //     uploadCopyOfResolutionB: this.personaldetailsForm.controls.uploadCopyOfResolutionB.value,
  //     // nameOfMemberO : this.personaldetailsForm.controls.nameOfMemberO.value,
  //     // address : this.personaldetailsForm.controls.address.value,
  //     // panNo : this.personaldetailsForm.controls.panNo.value,
  //     // uin : this.personaldetailsForm.controls.uin.value,
  //     // passportNumber : this.personaldetailsForm.controls.passportNumber.value,
  //     // adharNumber : this.personaldetailsForm.controls.adharNumber.value,
  //     // voterId : this.personaldetailsForm.controls.voterId.value,
  //     // others : this.personaldetailsForm.controls.others.value,
  //     // emailid : this.personaldetailsForm.controls.emailid.value,
  //     particularId: this.editParticularId,

  //   }
  //   console.log(" form ", this.personaldetailsForm);
  //   console.log(" obj 1 ", personaldata);

  //   if (this.filesToUpload != undefined && this.filesToUpload.length > 0) {
  //     this.upload().then(function (response) {
  //       if (response.status == 0) {
  //         personaldata['DocumentManagementID'] = response.result._id;
  //         personaldata['UploadDate'] = new Date();
  //         // personaldata['FileOrignalName'] = self.FileOrignalName;
  //         personaldata['FileOrignalName'] =  response.result.OriginalFileName;
  //         console.log(" obj in if ", personaldata);
  //         this.mgt1Service.updatePersonalDetails(personaldata).subscribe(response => {
  //           console.log("personalformentry", response);
  //           if (response.status == 0) {
  //             this.alert.success(response.message);
  //           } else {
  //             this.alert.error(response.message);
  //           }
  //         });
  //       }
  //     });
  //   } else {
  //     personaldata['DocumentManagementID'] = null;
  //     personaldata['UploadDate'] = null;
  //     personaldata['FileOrignalName'] = null;
  //     console.log(" obj in else ", personaldata);
  //     this.mgt1Service.updatePersonalDetails(personaldata).subscribe(response => {
  //       console.log("personalformentry", response);
  //       if (response.status == 0) {
  //         this.alert.success(response.message);
  //       } else {
  //         this.alert.error(response.message);
  //       }
  //     });
  //   }
  // }editParticularId

  generateOutput() {
    var object = {
      id: this.editParticularId,
      fromDate:this.dateFrom,
      toDate: this.dateTo
    }
    this.mgt1Service.generateDetailsOfHoldingDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            console.log('here')
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mgt1Service.downloadDetailsOfHoldingFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.mgt1Service.downloadDetailsOfHoldingPdfFile(id, 'Single');
  }
  updateDetailsOfMembers() {
    this.disabledOnClick = true;
    var domdata = {
      doBecomingMember: this.setDate(this.detailsOfMembersForm.controls.doBecomingMember.value),
      dateOfDeclaration: this.setDate(this.detailsOfMembersForm.controls.dateOfDeclaration.value),
      addNoterelatedToDeclaration: this.detailsOfMembersForm.controls.addNoterelatedToDeclaration.value,
      nameOfBeneficialowner: this.detailsOfMembersForm.controls.nameOfBeneficialowner.value,
      addressOfBeneficialOwner: this.detailsOfMembersForm.controls.addressOfBeneficialOwner.value,
      doReceiptOfNomination: this.setDate(this.detailsOfMembersForm.controls.doReceiptOfNomination.value),
      nameAndAddressOfNominee: this.detailsOfMembersForm.controls.nameAndAddressOfNominee.value,
      noOfSharesKeptInAbeyance: this.detailsOfMembersForm.controls.noOfSharesKeptInAbeyance.value,
      recordOfLienOnShares: this.detailsOfMembersForm.controls.recordOfLienOnShares.value,
      doCessationOfMemebership: this.setDate(this.detailsOfMembersForm.controls.doCessationOfMemebership.value),
      particularsOfDmPoa: this.detailsOfMembersForm.controls.particularsOfDmPoa.value,
      amountOfGuaranee: this.detailsOfMembersForm.controls.amountOfGuaranee.value,
      anyOtherInterest: this.detailsOfMembersForm.controls.anyOtherInterest.value,
      instructionForSendingNotices: this.detailsOfMembersForm.controls.instructionForSendingNotices.value,
      particularId: this.editParticularId

    }
    console.log("domdataform", this.detailsOfMembersForm);

    this.mgt1Service.updateDetailsOfMembers(domdata).subscribe(response => {
      this.disabledOnClick = false;
      console.log("domdataform", response);
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        // this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else {
          this.alert.error(response.message);
        }
      }
    })

  }


  getMgt1DetailsById(particularId) {
    this.mgt1Service.getMgt1DetailsById(particularId).subscribe(response => {
      console.log("response ", response);
      this.editParticularData = response.data[0];
      this.detailsOfSharesForm.controls.selectTypes.setValue(this.editParticularData.selectTypes);
      this.detailsOfSharesForm.controls.nominalValuePerUnit.setValue(this.editParticularData.nominalValuePerUnit);
      this.detailsOfSharesForm.controls.totalNoOfSharesHeld.setValue(this.editParticularData.totalNoOfSharesHeld);
      this.detailsOfSharesForm.controls.folioNoDematAcNo.setValue(this.editParticularData.folioNoDematAcNo);

      if (this.editParticularData.personalDetails) {
        let personalDetails = this.editParticularData.personalDetails;
        if (this.editParticularData.personalDetails.DocumentManagementID != null) {
          this.fileAvailable = true;
          this.canRevert = false;
          this.resolutionFileName = personalDetails.FileOrignalName;
          this.documentManagementID = personalDetails.DocumentManagementID;
        }
        this.typeOfShareholder = personalDetails.typesOfShareholders;
        this.isJointHolder = personalDetails.jointHolders;
        this.isMinor = personalDetails.inCaseMemberisMinor;
        this.minorMaritialStatus = personalDetails.maritialStatus;
        this.uniqueIdentification = personalDetails.uin;

        console.log("personalDetails ", personalDetails);
        console.log("typesOfShareholders ", personalDetails.maritialStatus);
        this.addPersonaldetailsBtn = false;
        this.personaldetailsForm.controls.typesOfShareholders.setValue(personalDetails.typesOfShareholders);
        this.personaldetailsForm.controls.nameOfMember.setValue(personalDetails.nameOfMember);
        this.personaldetailsForm.controls.jointHolders.setValue(personalDetails.jointHolders);
        this.personaldetailsForm.controls.nameOfjointHolders.setValue(personalDetails.nameOfjointHolders);
        this.personaldetailsForm.controls.address.setValue(personalDetails.address);
        this.personaldetailsForm.controls.panNo.setValue(personalDetails.panNo);
        this.personaldetailsForm.controls.jointHoldersPanNo.setValue(personalDetails.jointHoldersPanNo);
        this.personaldetailsForm.controls.uin.setValue(personalDetails.uin);

        this.personaldetailsForm.controls.passportNumber.setValue(personalDetails.passportNumber);
        this.personaldetailsForm.controls.adharNumber.setValue(personalDetails.adharNumber);

        this.personaldetailsForm.controls.voterId.setValue(personalDetails.voterId);
        this.personaldetailsForm.controls.others.setValue(personalDetails.others);
        this.personaldetailsForm.controls.nationality.setValue(personalDetails.nationality);
        this.personaldetailsForm.controls.emailid.setValue(personalDetails.emailid);
        this.personaldetailsForm.controls.fatherName.setValue(personalDetails.fatherName);
        this.personaldetailsForm.controls.motherName.setValue(personalDetails.motherName);
        this.personaldetailsForm.controls.inCaseMemberisMinor.setValue(personalDetails.inCaseMemberisMinor);
        // this.personaldetailsForm.controls.dob.setValue(personalDetails.dob);
        this.personaldetailsForm.controls.nameAndAddressOfGuardian.setValue(personalDetails.nameAndAddressOfGuardian);
        this.personaldetailsForm.controls.maritialStatus.setValue(personalDetails.maritialStatus);

        this.personaldetailsForm.controls.spouseName.setValue(personalDetails.spouseName);
        this.personaldetailsForm.controls.occupation.setValue(personalDetails.occupation);
        this.personaldetailsForm.controls.cinRegistrationNoB.setValue(personalDetails.cinRegistrationNoB);
        this.personaldetailsForm.controls.nameB.setValue(personalDetails.nameB);
        this.personaldetailsForm.controls.designationB.setValue(personalDetails.designationB);
        this.personaldetailsForm.controls.boardResolutionDateB.setValue(personalDetails.boardResolutionDateB);

        this.personaldetailsForm.controls.uploadCopyOfResolutionB.setValue(personalDetails.uploadCopyOfResolutionB);

        if (personalDetails.dob != null) {
          let dt = new Date(this.setFormatDate(personalDetails.dob));
          this.dateOfBirth = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (personalDetails.boardResolutionDateB != null) {
          let dt = new Date(this.setFormatDate(personalDetails.boardResolutionDateB));
          this.dateOfBoardResolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.addPersonaldetailsBtn = true;
      }

      if (this.editParticularData.detailsOfMembers) {
        let detailsOfMembers = this.editParticularData.detailsOfMembers
        this.addDomBtn = false;
        // this.detailsOfMembersForm.controls.doBecomingMember.setValue(detailsOfMembers.doBecomingMember);
        // this.detailsOfMembersForm.controls.dateOfDeclaration.setValue(detailsOfMembers.dateOfDeclaration);
        this.detailsOfMembersForm.controls.addNoterelatedToDeclaration.setValue(detailsOfMembers.addNoterelatedToDeclaration);
        this.detailsOfMembersForm.controls.nameOfBeneficialowner.setValue(detailsOfMembers.nameOfBeneficialowner);
        this.detailsOfMembersForm.controls.addressOfBeneficialOwner.setValue(detailsOfMembers.addressOfBeneficialOwner);
        // this.detailsOfMembersForm.controls.doReceiptOfNomination.setValue(detailsOfMembers.doReceiptOfNomination);
        this.detailsOfMembersForm.controls.nameAndAddressOfNominee.setValue(detailsOfMembers.nameAndAddressOfNominee);
        this.detailsOfMembersForm.controls.noOfSharesKeptInAbeyance.setValue(detailsOfMembers.noOfSharesKeptInAbeyance);
        this.detailsOfMembersForm.controls.recordOfLienOnShares.setValue(detailsOfMembers.recordOfLienOnShares);
        // this.detailsOfMembersForm.controls.doCessationOfMemebership.setValue(detailsOfMembers.doCessationOfMemebership);
        this.detailsOfMembersForm.controls.particularsOfDmPoa.setValue(detailsOfMembers.particularsOfDmPoa);
        this.detailsOfMembersForm.controls.amountOfGuaranee.setValue(detailsOfMembers.amountOfGuaranee);
        this.detailsOfMembersForm.controls.anyOtherInterest.setValue(detailsOfMembers.anyOtherInterest);
        this.detailsOfMembersForm.controls.instructionForSendingNotices.setValue(detailsOfMembers.instructionForSendingNotices);

        if (detailsOfMembers.doBecomingMember != null) {
          let dt = new Date(this.setFormatDate(detailsOfMembers.doBecomingMember));
          this.dateOfBecomingMember = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (detailsOfMembers.dateOfDeclaration != null) {
          let dt = new Date(this.setFormatDate(detailsOfMembers.dateOfDeclaration));
          this.doDeclaration = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (detailsOfMembers.doReceiptOfNomination != null) {
          let dt = new Date(this.setFormatDate(detailsOfMembers.doReceiptOfNomination));
          this.dateOfReceiptOfNomination = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (detailsOfMembers.doCessationOfMemebership != null) {
          let dt = new Date(this.setFormatDate(detailsOfMembers.doCessationOfMemebership));
          this.dateOfCessation = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        //  this.getHoldingList();

      } else {
        this.addDomBtn = true;
      }
      this.getHoldingList();
    })
  }

  fileChangeEvent(fileInput: any) {
    console.log("this.filesToUpload", this.filesToUpload)
    var checkfile = this.commonFunction.checkFileExtension(fileInput);

    if (checkfile) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
      this.canRevert = false;
    } else {
      this.fileExtension = false;
    }

    // this.filesToUpload = <Array<File>>fileInput.target.files;
    // this.canRevert = false;


    setTimeout(() => {
      if (fileInput.target.files[0] == undefined) {
        this.resolutionFileName = "";
        this.documentManagementID = null;
      }
      fileInput = null;
    }, 1000);
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');

        this.changedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  upload() {
    var file = this.filesToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var document = {
          "DocumentManagement": {
            "DocumentName": Date.now() + " - Document (MGT-1)",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": null,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Upload": this.changedName,
            "OriginalFileName": this.FileOrignalName,
            "FilePath": "",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(document)
          .toPromise().then(res => { return Promise.resolve(res); })

      }
    }, (error) => {
      this.alert.error("File format is not valid");
      return false;
    });
  }
  addFilesOnUpdate() {
    this.fileAvailable = false;
    this.canRevert = true;
    // this.filesToUpload = [];
    // this.resolutionFileName = "";
    // this.documentManagementID = null;
  }

  downloadCtcDoc(id) {
    //window.location.href = environment.pssUrl + this.downloadAllLink + id;
    window.location.href = environment.pssServerUrl + this.downloadAllLink + id + '/' + this.token;
  }
  revert() {
    this.canRevert = false;
    this.fileAvailable = true;
  }
  removeFile() {
    this.fileAvailable = false;
    this.filesToUpload = [];
    this.resolutionFileName = "";
    this.documentManagementID = null;
  }


  getHoldingList() {
    this.holdingList = [];
    var Id = this.editParticularId;
    console.log(Id)
    var searchParam =
    {
      "dateFrom": null,
      "dateTo": null,
      'isSearch': false,
    };
    this.mgt1Service.getHoldingList(Id, searchParam).subscribe(holdingList => {
      var list = holdingList.data;
      this.holdingList = holdingList.data;
      console.log("holdingList*********", this.holdingList);
      this.dtTriggerHolding.next();
    });
  }


  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "dateFrom": this.setDate(this.dateFrom),
      "dateTo": this.setDate(this.dateTo),
      'isSearch': true,
    };
    this.holdingList = [];
    $("#detailsOfHoldinglistTable").DataTable().destroy();
    var Id = this.editParticularId;
    this.mgt1Service.getHoldingList(Id, searchParam).subscribe(holdingList => {
      console.log("holdingList*********", holdingList);
      this.response = false;
      var list = holdingList.data;
      this.holdingList = holdingList.data;
      console.log("holdingList*********", this.holdingList);
      this.dtTriggerHolding.next();
    });
  }
  clearAdvSearch() {

    this.dateFrom = undefined;
    this.dateTo = undefined;
    $("#detailsOfHoldinglistTable").DataTable().destroy();
    this.getHoldingList();
  }

  editholdingdetails(id) {
    this.addholding = false;
    // var data =  this.holdingList[];
    var data = this.holdingList.filter(function (item) {
      return item.detailsOfHoldings._id == id;
    });
    this.holdingdata = data[0].detailsOfHoldings;
    $("#addNewForm").modal('toggle');
    // this.addNewFields();

    var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    console.log("addNewTermsheetFieldForm", this.addNewTermsheetFieldForm);
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);


    // this.typesOfHolders = this.holdingdata.typesOfHolders;

    formGroup.controls.typesOfHolders.setValue(this.holdingdata.typesOfHolders);
    formGroup.controls.allotmentNo.setValue(this.holdingdata.allotmentNo);
    //  formGroup.controls.dateOfAllotment.setValue(this.holdingdata.dateOfAllotment);
    formGroup.controls.noOfSharesAlloted.setValue(this.holdingdata.noOfSharesAlloted);
    formGroup.controls.distinctiveFrom.setValue(this.holdingdata.distinctiveFrom);
    formGroup.controls.distinctiveTo.setValue(this.holdingdata.distinctiveTo);
    formGroup.controls.folioOfTransferor.setValue(this.holdingdata.folioOfTransferor);
    formGroup.controls.nameOfTransferor.setValue(this.holdingdata.nameOfTransferor);
    formGroup.controls.certificateNo.setValue(this.holdingdata.certificateNo);
    formGroup.controls.lackInPeriod.setValue(this.holdingdata.lackInPeriod);
    formGroup.controls.amountPayable.setValue(this.holdingdata.amountPayable);
    formGroup.controls.amountPaid.setValue(this.holdingdata.amountPaid);
    formGroup.controls.amountDue.setValue(this.holdingdata.amountDue);
    formGroup.controls.sharesIssued.setValue(this.holdingdata.sharesIssued);
    //  formGroup.controls.dateOfTransfer.setValue(this.holdingdata.dateOfTransfer);
    //  formGroup.controls.dateOfTransmission.setValue(this.holdingdata.dateOfTransmission);
    //  formGroup.controls.dateOfForfeiture.setValue(this.holdingdata.dateOfForfeiture);
    //  formGroup.controls.dateOfRedemption.setValue(this.holdingdata.dateOfRedemption);
    //  formGroup.controls.dateOfBuyback.setValue(this.holdingdata.dateOfBuyback);
    formGroup.controls.noofsharestransfer.setValue(this.holdingdata.noofsharestransfer);
    formGroup.controls.noofsharestransmission.setValue(this.holdingdata.noofsharestransmission);
    formGroup.controls.noofsharesforfeiture.setValue(this.holdingdata.noofsharesforfeiture);
    formGroup.controls.noofsharesredemption.setValue(this.holdingdata.noofsharesredemption);
    formGroup.controls.noofsharesbuyback.setValue(this.holdingdata.noofsharesbuyback);
    formGroup.controls.distinctiveTransferredFrom.setValue(this.holdingdata.distinctiveTransferredFrom);
    formGroup.controls.distinctiveTransferredTo.setValue(this.holdingdata.distinctiveTransferredTo);
    formGroup.controls.distinctiveTransmittedFrom.setValue(this.holdingdata.distinctiveTransmittedFrom);
    formGroup.controls.distinctiveTransmittedTo.setValue(this.holdingdata.distinctiveTransmittedTo);
    formGroup.controls.distinctiveForfeitedFrom.setValue(this.holdingdata.distinctiveForfeitedFrom);
    formGroup.controls.distinctiveForfeitedTo.setValue(this.holdingdata.distinctiveForfeitedTo);
    formGroup.controls.distinctiveRedeemedFrom.setValue(this.holdingdata.distinctiveRedeemedFrom);
    formGroup.controls.distinctiveRedeemedTo.setValue(this.holdingdata.distinctiveRedeemedTo);
    formGroup.controls.distinctiveBuybackFrom.setValue(this.holdingdata.distinctiveBuybackFrom);
    formGroup.controls.distinctiveBuybackTo.setValue(this.holdingdata.distinctiveBuybackTo);
    formGroup.controls.folioOfTransferee.setValue(this.holdingdata.folioOfTransferee);
    formGroup.controls.nameOfTransferee.setValue(this.holdingdata.nameOfTransferee);
    formGroup.controls.balancesharestransfer.setValue(this.holdingdata.balancesharestransfer);
    formGroup.controls.balancesharestransmission.setValue(this.holdingdata.balancesharestransmission);
    formGroup.controls.balancesharesforfeiture.setValue(this.holdingdata.balancesharesforfeiture);
    formGroup.controls.balancesharesredemption.setValue(this.holdingdata.balancesharesredemption);
    formGroup.controls.balancesharesbuyback.setValue(this.holdingdata.balancesharesbuyback);
    formGroup.controls.remarks.setValue(this.holdingdata.remarks);

    this.pipe = new DatePipe('en-US');

    //  if (this.holdingdata.dateOfAllotment != null) {
    //   formGroup.controls.dateOfAllotment.setValue(this.pipe.transform(this.holdingdata.dateOfAllotment, 'yyyy-MM-dd'));
    // }

    if (this.holdingdata.dateOfAllotment != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.dateOfAllotment));
      formGroup.controls.dateOfAllotment.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

    if (this.holdingdata.dateOfIssue != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.dateOfIssue));
      // formGroup.controls.dateOfIssue.setValue(this.pipe.transform(this.holdingdata.dateOfIssue, 'yyyy-MM-dd'));
      formGroup.controls.dateOfIssue.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

    if (this.holdingdata.dateOfTransfer != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.dateOfTransfer));
      // formGroup.controls.dateOfTransfer.setValue(this.pipe.transform(this.holdingdata.dateOfTransfer, 'yyyy-MM-dd'));
      formGroup.controls.dateOfTransfer.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }
    // if (this.holdingdata.dateOfTransmission != null) {
    //   let dt = new Date(this.setFormatDate(this.holdingdata.dateOfTransmission));

    //   formGroup.controls.dateOfTransmission.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    // }
    // if (this.holdingdata.dateOfForfeiture != null) {
    //   let dt = new Date(this.setFormatDate(this.holdingdata.dateOfForfeiture));

    //   formGroup.controls.dateOfForfeiture.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    // }
    // if (this.holdingdata.dateOfRedemption != null) {
    //   let dt = new Date(this.setFormatDate(this.holdingdata.dateOfRedemption));

    //   formGroup.controls.dateOfRedemption.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    // }
    // if (this.holdingdata.dateOfBuyback != null) {
    //   let dt = new Date(this.setFormatDate(this.holdingdata.dateOfBuyback));

    //   formGroup.controls.dateOfBuyback.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    // }

  }
  dateSet(date) {

    if (date != "" && date != null) {
      if (date.month != undefined && date.day != undefined && date.year != undefined) {
        return date.month + "-" + date.day + "-" + date.year;
      }
      else return date;
    }
    return null;
  }


  updateHoldingDetails() {
    this.disabledOnClick = true;


    this.array = this.addNewTermsheetFieldForm.controls.newField;
    var item = this.array.controls[0];

    var holddata = {
      _id: this.holdingdata._id,
      typesOfHolders: item.controls.typesOfHolders.value,
      allotmentNo: item.controls.allotmentNo.value,
      dateOfAllotment: this.dateSet(item.controls.dateOfAllotment.value),
      noOfSharesAlloted: item.controls.noOfSharesAlloted.value,
      distinctiveFrom: item.controls.distinctiveFrom.value,
      distinctiveTo: item.controls.distinctiveTo.value,
      folioOfTransferor: item.controls.folioOfTransferor.value,
      nameOfTransferor: item.controls.nameOfTransferor.value,
      dateOfIssue: this.dateSet(item.controls.dateOfIssue.value),
      certificateNo: item.controls.certificateNo.value,
      lackInPeriod: item.controls.lackInPeriod.value,
      amountPayable: item.controls.amountPayable.value,
      amountPaid: item.controls.amountPaid.value,
      amountDue: item.controls.amountDue.value,
      sharesIssued: item.controls.sharesIssued.value,
      // dateOfTransmission: this.dateSet(item.controls.dateOfTransmission.value),
      // dateOfForfeiture: this.dateSet(item.controls.dateOfForfeiture.value),
      // dateOfRedemption: this.dateSet(item.controls.dateOfRedemption.value),
      dateOfTransfer: this.dateSet(item.controls.dateOfTransfer.value),
      // dateOfBuyback: this.dateSet(item.controls.dateOfBuyback.value),
      noofsharestransfer: item.controls.noofsharestransfer.value,
      noofsharestransmission: item.controls.noofsharestransmission.value,
      noofsharesforfeiture: item.controls.noofsharesforfeiture.value,
      noofsharesredemption: item.controls.noofsharesredemption.value,
      noofsharesbuyback: item.controls.noofsharesbuyback.value,
      distinctiveTransferredFrom: item.controls.distinctiveTransferredFrom.value,
      distinctiveTransferredTo: item.controls.distinctiveTransferredTo.value,
      distinctiveTransmittedFrom: item.controls.distinctiveTransmittedFrom.value,
      distinctiveTransmittedTo: item.controls.distinctiveTransmittedTo.value,
      distinctiveForfeitedFrom: item.controls.distinctiveForfeitedFrom.value,
      distinctiveForfeitedTo: item.controls.distinctiveForfeitedTo.value,
      distinctiveRedeemedFrom: item.controls.distinctiveRedeemedFrom.value,
      distinctiveRedeemedTo: item.controls.distinctiveRedeemedTo.value,
      distinctiveBuybackFrom: item.controls.distinctiveBuybackFrom.value,
      distinctiveBuybackTo: item.controls.distinctiveBuybackTo.value,
      folioOfTransferee: item.controls.folioOfTransferee.value,
      nameOfTransferee: item.controls.nameOfTransferee.value,
      balancesharestransfer: item.controls.balancesharestransfer.value,
      balancesharestransmission: item.controls.balancesharestransmission.value,
      balancesharesforfeiture: item.controls.balancesharesforfeiture.value,
      balancesharesredemption: item.controls.balancesharesredemption.value,
      balancesharesbuyback: item.controls.balancesharesbuyback.value,
      remarks: item.controls.remarks.value
    }

    var object = {
      particularId: this.editParticularId,
      id: this.holdingdata._id,
      // data: this.addNewTermsheetFieldForm.controls.newField.value[0]
      data: holddata
    };

    console.log("newField", this.addNewTermsheetFieldForm.controls.newField.value);

    this.mgt1Service.updateDetailsOfHolding(object).subscribe(response => {
      this.disabledOnClick = false;
      console.log("holdingdata", response);
      if (response.status == 0) {
        this.alert.success(response.message);

        this.getHoldingList();
      } else {
        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else {
          this.alert.error(response.message);
        }

        this.resetFields();
        $("#detailsOfHoldinglistTable").DataTable().destroy();

      }
      this.resetFields();
    })
    this.addholding = true;
    $("#detailsOfHoldinglistTable").DataTable().destroy();
    $("#addNewForm .close").click();

  }

  confirmDelete(_id) {
    this.deleteholdingId = _id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteholdingdetail() {
    var Id = this.editParticularId;
    this.mgt1Service.deleteholdingDetails(this.deleteholdingId, Id).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);

        $("#deleteConfirm").modal('toggle');
        // this.getHoldingList();
        $("#detailsOfHoldinglistTable").DataTable().destroy();
      } else {
        this.alert.error(response.message);
        $("#deleteConfirm").modal('toggle');
        $("#detailsOfHoldinglistTable").DataTable().destroy();
      }
      this.getHoldingList();
    });
  }

  addNewFieldsModal() {
    this.addholding = true;
    $("#addNewForm").modal('toggle');
    this.addNewFields();
  }

  addNewFields() {

    var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    console.log("addNewTermsheetFieldForm", this.addNewTermsheetFieldForm);
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }


  removeField(index) {
    var newFieldData = this.addNewTermsheetFieldForm.controls.newField.value;
    this.newFieldArray.splice(index, 1);
    var formArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    formArray.removeAt(index)
  }

  initialiseNewFieldArray(): FormGroup {
    return this.formBuilder.group({
      typesOfHolders: new FormControl('', [Validators.required]),
      allotmentNo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,/-]*$"), Validators.maxLength(20)]),
      dateOfAllotment: new FormControl(null, []),
      noOfSharesAlloted: new FormControl('', [Validators.pattern("^[0-9 ./-]*$"), Validators.maxLength(20)]),
      distinctiveFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ]*$"), Validators.maxLength(20)]),
      distinctiveTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ]*$"), Validators.maxLength(20)]),
      folioOfTransferor: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      nameOfTransferor: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&-]*$"), Validators.maxLength(100)]),
      dateOfIssue: new FormControl(null, []),
      certificateNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ./]*$"), Validators.maxLength(20)]),
      lackInPeriod: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ./]*$"), Validators.maxLength(20)]),
      amountPayable: new FormControl('', [Validators.pattern("^[0-9 ./]*$"), Validators.maxLength(20)]),
      amountPaid: new FormControl('', [Validators.pattern("^[0-9 ./]*$"), Validators.maxLength(20)]),
      amountDue: new FormControl('', [Validators.pattern("^[0-9 ./]*$"), Validators.maxLength(20)]),
      sharesIssued: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&/-]*$"), Validators.maxLength(1000)]),
      dateOfTransfer: new FormControl(null, []),
      // dateOfTransmission: new FormControl(null, []),
      // dateOfForfeiture: new FormControl(null, []),
      // dateOfRedemption: new FormControl(null, []),
      // dateOfBuyback: new FormControl(null, []),
      noofsharestransfer: new FormControl('', [Validators.pattern("^[0-9 .,/-]*$"), Validators.maxLength(20)]),
      noofsharestransmission: new FormControl('', [Validators.pattern("^[0-9 .,/-]*$"), Validators.maxLength(20)]),
      noofsharesforfeiture: new FormControl('', [Validators.pattern("^[0-9 .,/-]*$"), Validators.maxLength(20)]),
      noofsharesredemption: new FormControl('', [Validators.pattern("^[0-9 .,/-]*$"), Validators.maxLength(20)]),
      noofsharesbuyback: new FormControl('', [Validators.pattern("^[0-9 .,/-]*$"), Validators.maxLength(20)]),
      distinctiveTransferredFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveTransferredTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveTransmittedFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveTransmittedTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveForfeitedFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveForfeitedTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveRedeemedFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveRedeemedTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveBuybackFrom: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveBuybackTo: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      folioOfTransferee: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,/-]*$"), Validators.maxLength(20)]),
      nameOfTransferee: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&/-]*$"), Validators.maxLength(100)]),
      balancesharestransfer: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      balancesharestransmission: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      balancesharesforfeiture: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      balancesharesredemption: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      balancesharesbuyback: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      remarks: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&/-]*$"), Validators.maxLength(1000)]),
    })
  }

  saveDetailsOfHolding() {
    this.disabledOnClick = true;
    //  var object = this.addNewTermsheetFieldForm.controls.newField.value;
    // this.addNewTermsheetFieldForm.controls.newField.array.forEach(element => {
    //   formGroup.controls.dateOfAllotment.this.dateSet(item.controls.dateOfAllotment.value),

    // });

    // var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    // const index = _.size(formArray.controls);
    // for(let i = index-1; i >= 0; i--) {
    // var formGroup: FormGroup = <FormGroup>formArray.controls[i];
    this.holdersdata = [];
    this.addNewTermsheetFieldForm.controls.newField.value.forEach((item, i) => {
      let updatedObject = {

        typesOfHolders: this.addNewTermsheetFieldForm.controls.newField.value[i].typesOfHolders,
        allotmentNo: this.addNewTermsheetFieldForm.controls.newField.value[i].allotmentNo,
        dateOfAllotment: this.setDate(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfAllotment),
        noOfSharesAlloted: this.addNewTermsheetFieldForm.controls.newField.value[i].noOfSharesAlloted,
        distinctiveFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveFrom,
        distinctiveTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveTo,
        folioOfTransferor: this.addNewTermsheetFieldForm.controls.newField.value[i].folioOfTransferor,
        nameOfTransferor: this.addNewTermsheetFieldForm.controls.newField.value[i].nameOfTransferor,
        dateOfIssue: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfIssue),
        certificateNo: this.addNewTermsheetFieldForm.controls.newField.value[i].certificateNo,
        lackInPeriod: this.addNewTermsheetFieldForm.controls.newField.value[i].lackInPeriod,
        amountPayable: this.addNewTermsheetFieldForm.controls.newField.value[i].amountPayable,
        amountPaid: this.addNewTermsheetFieldForm.controls.newField.value[i].amountPaid,
        amountDue: this.addNewTermsheetFieldForm.controls.newField.value[i].amountDue,
        sharesIssued: this.addNewTermsheetFieldForm.controls.newField.value[i].sharesIssued,
        // dateOfTransmission: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfTransmission),
        // dateOfForfeiture: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfForfeiture),
        // dateOfRedemption: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfRedemption),
        dateOfTransfer: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfTransfer),
        // dateOfBuyback: this.dateSet(this.addNewTermsheetFieldForm.controls.newField.value[i].dateOfBuyback),
        noofsharestransfer: this.addNewTermsheetFieldForm.controls.newField.value[i].noofsharestransfer,
        noofsharestransmission: this.addNewTermsheetFieldForm.controls.newField.value[i].noofsharestransmission,
        noofsharesforfeiture: this.addNewTermsheetFieldForm.controls.newField.value[i].noofsharesforfeiture,
        noofsharesredemption: this.addNewTermsheetFieldForm.controls.newField.value[i].noofsharesredemption,
        noofsharesbuyback: this.addNewTermsheetFieldForm.controls.newField.value[i].noofsharesbuyback,
        distinctiveTransferredFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveTransferredFrom,
        distinctiveTransferredTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveTransferredTo,
        distinctiveTransmittedFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveTransmittedFrom,
        distinctiveTransmittedTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveTransmittedTo,
        distinctiveForfeitedFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveForfeitedFrom,
        distinctiveForfeitedTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveForfeitedTo,
        distinctiveRedeemedFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveRedeemedFrom,
        distinctiveRedeemedTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveRedeemedTo,
        distinctiveBuybackFrom: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveBuybackFrom,
        distinctiveBuybackTo: this.addNewTermsheetFieldForm.controls.newField.value[i].distinctiveBuybackTo,
        folioOfTransferee: this.addNewTermsheetFieldForm.controls.newField.value[i].folioOfTransferee,
        nameOfTransferee: this.addNewTermsheetFieldForm.controls.newField.value[i].nameOfTransferee,
        balancesharestransfer: this.addNewTermsheetFieldForm.controls.newField.value[i].balancesharestransfer,
        balancesharestransmission: this.addNewTermsheetFieldForm.controls.newField.value[i].balancesharestransmission,
        balancesharesforfeiture: this.addNewTermsheetFieldForm.controls.newField.value[i].balancesharesforfeiture,
        balancesharesredemption: this.addNewTermsheetFieldForm.controls.newField.value[i].balancesharesredemption,
        balancesharesbuyback: this.addNewTermsheetFieldForm.controls.newField.value[i].balancesharesbuyback,
        remarks: this.addNewTermsheetFieldForm.controls.newField.value[i].remarks
      }
      console.log("updatedObject ", updatedObject);

      this.holdersdata.push(updatedObject);
    });

    var object = {
      particularId: this.editParticularId,
      // data:this.addNewTermsheetFieldForm.controls.newField.value
      data: this.holdersdata
    };
    console.log("newField", this.addNewTermsheetFieldForm.controls.newField);
    this.mgt1Service.saveDetailsOfHolding(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);

        this.getHoldingList();
        $("#detailsOfHoldinglistTable").DataTable().destroy();


      } else {
        $("#detailsOfHoldinglistTable").DataTable().destroy();
        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
        $("#addNewForm .close").click()
      }

      $("#addNewForm .close").click()
      this.resetFields();

    })

  }

  resetFields() {
    var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    const index = _.size(formArray.controls);
    for (let i = index - 1; i >= 0; i--) {
      this.newFieldArray.splice(i, 1);
      formArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
      formArray.removeAt(i)
    }
  }
  backMGT1(){
    
this.router.navigate(
  [{ outlets: { 'structure-outlet': ['mgt1']  } }],
  { relativeTo: this.route.parent });
  }
}
